import React from "react";
import { Row, Col } from "react-bootstrap";
import { Element } from "react-scroll";
import Location from "../../Asset/icon/location.svg";
import IslandDetail from "./islandAssetDetail";
import { useTranslation } from "react-i18next";
import "../../Asset/scss/takemyyacht.scss";

const IslandCard = ({
  Image,
  name,
  provinceName,
  provinceCountry,
  agentLenght,
  yachtLenght,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <Row className="align-items-start mb-4">
        {/* รูปภาพอยู่บนสุด */}
        <Col xs={12} className="mb-3">
          {Image ? (
            <img
              src={Image}
              draggable={false}
              alt="ProvinceImage"
              className="img-fluid rounded"
            />
          ) : (
            <div
              className="p-4 rounded border shadow-sm d-flex justify-content-center align-items-center text-muted fst-italic content-placeholder"
            >
              {t("No destination image available")}
            </div>
          )}
        </Col>

        <div className="flex-row">
          <div>
            {/* แถวสอง: ข้อความซ้าย + IslandDetail ขวา */}
            <Col xs={12} md={12} className="province-des text-left">
              <div>
                <div className="align-items-center">
                  <h4 className="mt-2 mb-0">{name}</h4>
                  <div className="d-flex align-items-center content mb-0">
                    <img
                      draggable={false}
                      src={Location}
                      alt="location-IslandCard"
                      className="icon-style img-fluid"
                    />
                    <p className="content-text">{provinceName}</p>
                  </div>

                  <p className="mb-0 text-decoration-underline">
                    {t("Description")}
                  </p>

                  <Element
                    name="test7"
                    className="element"
                    id="containerElement"
                  >
                    <Element
                      name="firstInsideContainer"
                      className="first-inside-container"
                    >
                      {description ? (
                        <p>{description}</p>
                      ) : (
                        <div
                          className="p-3 mb-2 rounded text-center mr-2rem"
                        >
                          <span className="text-muted fst-italic">
                            {t("No destination details available")}
                          </span>
                        </div>
                      )}
                    </Element>
                  </Element>
                </div>
              </div>
            </Col>
          </div>

          <div>
            <Col
              xs={12}
              md={4}
              className="provice-detail align-self-start mt-3 mt-md-0 display-block"
            >
              <IslandDetail
                AgentLenght={agentLenght}
                YachtLenght={yachtLenght}
              />
            </Col>
          </div>
        </div>
      </Row>
    </div>
  );
};

export default IslandCard;
